import { ButtonDS, DialogModalDS } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import "../../../../i18n/i18n";

const modalName = "linky_consents.modal.homeChargingDrivers";

export const HomeChargingDriversModal = (props: {
  visible: boolean;
  onCloseModal: () => void;
}) => {
  const { t } = useTranslation();
  const { visible, onCloseModal } = props;

  return (
    <DialogModalDS
      visible={visible}
      width={44}
      onClose={onCloseModal}
      title={t(`${modalName}.title`) || ""}
      subTitle={t(`${modalName}.subTitle`) || ""}
      bottomButton={
        <ButtonDS
          text={t(`${modalName}.cancel`)}
          format={"fill"}
          buttonType={"secondary"}
          onClick={onCloseModal}
        />
      }
    >
      <StyledModalContainer />
    </DialogModalDS>
  );
};

const StyledModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
